export default __webpack_public_path__ + "static/migrolino-04e97026cb1db88837f0c3932ec4c68b.png";